import { Component } from 'react';

import QuestionType from '../../../../components/question/question-type-container';

import Checkbox from '../../../../components/checkbox';
import Input from '../../../../components/input-with-label';

import QuestionTypeField from './question-type-field';

import Dropdown from '../../../../components/dropdowns/dropdown';

import { AddButton } from '../../../../components/buttons';

function Field({ title, children }) {
    return (
        <div className="field">
            <p className="field__label">{ title }</p>
            { children }
        </div>
    )
}

export default class QuestionTypeDatePickef extends Component {
    constructor(props) {
        super(props);

        this.state = {
            radio_buttons: [{
                allow_date_range: false
            }]
        }

        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
        this.setState(Object.assign({}, this.state, this.props.question), () => console.log(this.state));
    }

    onInputChange(e) {
        const { name, value } = e.target;
        const { grantVersion, sectionIndex, blockIndex, questionIndex } = this.props;

        let params = { [ name ]: value }

        this.setState(params, () => {
            this.props.grantStateHandler.updateQuestion(grantVersion, sectionIndex, blockIndex, questionIndex, this.state);
        });
    }

    render() {
        return (
            <div className="question-type__outer">
                <QuestionType type='date-picker' title="Date Picker Settings">
                    <Field title="Date Criteria">
                    <Checkbox checked={this.state.allow_date_range} 
                        name="allow_date_range" 
                        text="Allow date range input" 
                        onChange={this.onInputChange}/>
                    </Field>
                </QuestionType>
            </div>
        )
    }
}   